
// Slider value display
document.querySelectorAll('input[type="range"].slider').forEach((r) => {
  const display = document.querySelector(`[data-slider-display="${r.id}"]`);
  if (!display) return;
  const suffix = r.id === 'volume' ? '%' : (r.id === 'font-size' ? 'px' : '');
  r.addEventListener('input', () => { display.textContent = r.value + suffix; });
});

// Color swatch selection
document.querySelectorAll('.color-grid').forEach((grid) => {
  grid.addEventListener('click', (e) => {
    const sw = e.target.closest('.color-swatch');
    if (!sw) return;
    grid.querySelectorAll('.color-swatch').forEach((s) => s.classList.remove('active'));
    sw.classList.add('active');
  });
});

// Stepper +/-
document.querySelectorAll('.stepper').forEach((step) => {
  const input = step.querySelector('input');
  step.querySelectorAll('button[data-step]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const delta = parseInt(btn.dataset.step, 10);
      const min = parseInt(input.min || '-Infinity', 10);
      const max = parseInt(input.max || 'Infinity', 10);
      const next = Math.max(min, Math.min(max, (parseInt(input.value, 10) || 0) + delta));
      input.value = next;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });
});

// Tag input
document.querySelectorAll('.tag-input').forEach((wrap) => {
  const input = wrap.querySelector('input');
  wrap.addEventListener('click', (e) => {
    if (e.target === wrap) input.focus();
    const close = e.target.closest('.tag-pill button');
    if (close) close.closest('.tag-pill').remove();
  });
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && input.value.trim()) {
      e.preventDefault();
      const pill = document.createElement('span');
      pill.className = 'tag-pill';
      pill.innerHTML = input.value.trim().replace(/[<>&]/g, '') + '<button type="button" aria-label="Remove">×</button>';
      wrap.insertBefore(pill, input);
      input.value = '';
    } else if (e.key === 'Backspace' && !input.value) {
      const last = wrap.querySelector('.tag-pill:last-of-type');
      if (last) last.remove();
    }
  });
});

// Rating
document.querySelectorAll('.rating').forEach((rating) => {
  const stars = [...rating.querySelectorAll('button')];
  stars.forEach((star, i) => {
    star.addEventListener('click', () => {
      stars.forEach((s, j) => s.classList.toggle('on', j <= i));
      rating.dataset.rating = String(i + 1);
    });
  });
});

// File input — show selected name
document.querySelectorAll('.file-input input[type="file"]').forEach((inp) => {
  const display = inp.closest('.file-input').querySelector('.file-input-name');
  if (!display) return;
  inp.addEventListener('change', () => {
    if (inp.files?.[0]) display.textContent = inp.files[0].name;
  });
});

// OTP — auto-advance
document.querySelectorAll('.otp-grid').forEach((grid) => {
  const inputs = [...grid.querySelectorAll('.otp-input')];
  inputs.forEach((inp, i) => {
    inp.addEventListener('input', () => {
      if (inp.value && i < inputs.length - 1) inputs[i + 1].focus();
    });
    inp.addEventListener('keydown', (e) => {
      if (e.key === 'Backspace' && !inp.value && i > 0) inputs[i - 1].focus();
    });
  });
});

// Char counter
document.querySelectorAll('[data-char-counter]').forEach((el) => {
  const display = document.querySelector(`[data-char-display="${el.id}"]`);
  if (!display) return;
  const update = () => { display.textContent = String(el.value.length); };
  el.addEventListener('input', update);
  update();
});

// Password strength
const newPwd = document.getElementById('newPwd');
if (newPwd) {
  const meter = newPwd.closest('.form-group')?.querySelector('.password-strength');
  const label = newPwd.closest('.form-group')?.querySelector('.password-strength-label strong');
  const score = (v) => {
    let s = 0;
    if (v.length >= 8) s++;
    if (v.length >= 12) s++;
    if (/[A-Z]/.test(v) && /[a-z]/.test(v)) s++;
    if (/\d/.test(v) && /[^A-Za-z0-9]/.test(v)) s++;
    return s;
  };
  const labels = ['Empty', 'Weak', 'Fair', 'Good', 'Strong'];
  newPwd.addEventListener('input', () => {
    const s = score(newPwd.value);
    if (meter) meter.className = `password-strength s${s}`;
    if (label) label.textContent = labels[s];
  });
}
